import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ChargingStationsService } from '@services/entity/charging-stations.service';
import { ChargingStationDto } from '@dto/chargingStationDto';
import { ToastService } from '@services/toast/toast.service';
import { EventService } from '@services/event/event.service';
import { ChangeAvailabilityRequest } from '@dto/ocpp/ChangeAvailabilityRequest';
import { AvailabilityType } from '@enums/AvailabilityType.enum';

@Component({
  selector: 'app-technical-charging-station-actions-modal',
  templateUrl: './technical-charging-station-actions-modal.component.html',
  styleUrls: ['./technical-charging-station-actions-modal.component.scss'],
})
export class TechnicalChargingStationActionsModalComponent {
  @Input() station: ChargingStationDto;
  loadingAction: string | null = null;

  constructor(
    public activeModal: NgbActiveModal,
    private chargingStationsService: ChargingStationsService,
    private toastService: ToastService,
    private eventService: EventService
  ) {}

  runReset(mode: 'SOFT' | 'HARD'): void {
    this.loadingAction = 'reset-' + mode;
    this.chargingStationsService.resetChargingstation(this.station.id, mode).subscribe({
      next: () => {
        this.toastService.success(mode === 'SOFT' ? 'Neustart (SOFT) ausgeführt.' : 'Neustart (HARD) ausgeführt.');
        this.eventService.sendEntityRefresh();
        this.activeModal.close();
      },
      error: () => {
        this.loadingAction = null;
        this.toastService.error('Neustart fehlgeschlagen.');
      },
    });
  }

  setAvailability(operative: boolean): void {
    this.loadingAction = operative ? 'unlock' : 'lock';
    const request: ChangeAvailabilityRequest = {
      connectorId: 0,
      type: operative ? AvailabilityType.OPERATIVE : AvailabilityType.INOPERATIVE,
    };
    this.chargingStationsService.changeAvailability(this.station.id, request).subscribe({
      next: () => {
        this.toastService.success(operative ? 'Ladestation entsperrt.' : 'Ladestation gesperrt.');
        this.eventService.sendEntityRefresh();
        this.activeModal.close();
      },
      error: () => {
        this.loadingAction = null;
        this.toastService.error(operative ? 'Entsperren fehlgeschlagen.' : 'Sperren fehlgeschlagen.');
      },
    });
  }

  toggleRoaming(): void {
    this.loadingAction = 'roaming';
    const enable = !this.station.isHubjectAvailable;
    const req = enable
      ? this.chargingStationsService.enableHubjectERoaming(this.station.id)
      : this.chargingStationsService.disableHubjectERoaming(this.station.id);
    req.subscribe({
      next: () => {
        this.toastService.success(enable ? 'Roaming aktiviert.' : 'Roaming deaktiviert.');
        this.eventService.sendEntityRefresh();
        this.activeModal.close();
      },
      error: () => {
        this.loadingAction = null;
        this.toastService.error('Roaming-Umschaltung fehlgeschlagen.');
      },
    });
  }

  cancel(): void {
    this.activeModal.dismiss();
  }
}
